var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"footer",staticStyle:{"height":"30px"}},[_c('p',[_vm._v("Copyright © 2019 上海携恒信息技术有限公司 版权所有 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }